/** Traditional Seventh Step Prayer from Alcoholics Anonymous, page 76. */
export const TRADITIONAL_SEVENTH_STEP_PRAYER =
  'My Creator, I am now willing that you should have all of me, good and bad. I pray that you now remove from me every single defect of character which stands in the way of my usefulness to you and my fellows. Grant me strength as I go out from here to do your bidding. Amen';

export const TRADITIONAL_SEVENTH_STEP_PRAYER_SOURCE =
  'AA Big Book, page 76';
